import React, { useEffect, useState } from "react";
import Modal from "components/Models/index";
import profileImage from "assets/images/fileImage/profileImage.svg";
// import Button from "components/Button/index";
import useScreenMobile from "hooks/useScreen";
import Drawer from "components/Drawer/index";
import ShareProject from "../ShareProject/index";
import "./fileInformation.scss";
import { useToast } from "components/Toaster/index";
import FileInfoChild from "./FileInfoChild/index";
import { Item, Folder, File, ManageUser, StoragePlan } from "@induz/sdk";
// import { bytesToMB } from "utils/helperFunction";

// const fileType = [
//   {
//     fileType: "Type",
//     fileName: "Excel sheet
//   },
//   {
//     fileType: "Size",
//     fileName: "2.5 KB"
//   },
//   {
//     fileType: "Storage used",
//     fileName: "2.5 KB"
//   },
//   {
//     fileType: "Owner",
//     fileName: "You"
//   },
//   {
//     fileType: "Modified",
//     fileName: "Dec 20, 2024"
//   },
//   {
//     fileType: "Created",
//     fileName: "Mar 13, 2024"
//   }
// ];

const fileHasGiven = [
  {
    image: profileImage,
    name: "Vignesh"
  },
  {
    image: profileImage,
    name: "Vignesh"
  },
  {
    image: profileImage,
    name: "Vignesh"
  },
  {
    image: profileImage,
    name: "Vignesh"
  },
  {
    image: profileImage,
    name: "Vignesh"
  },
  {
    image: profileImage,
    name: "Vignesh"
  }
];

const FileInformationContent = ({ handleMange, selectedRow, currentPath, centered }) => {
  // const [manage, setManage] = useState(false);

  // const handleMange = () => {
  //   setManage(!manage);
  // };
  const showToast = useToast();

  const [detailsObj, setDetailsObj] = useState({
    type: null,
    size: null,
    storage: null,
    owner: null,
    modifiedDate: null,
    createdDate: null,
    tags: [],
    whoHasAccess: [...fileHasGiven],
    isFolder: false
  });

  const [isEditingTags, setIsEditingTags] = useState(false);
  const [tagInput, setTagInput] = useState("");

  const isExternalShare = currentPath[0] === "external_shared" || currentPath[0] === "shared";

  const convertUTCToLocal = (dateString) => {
    if (!dateString) return "";

    const isoUTC = dateString.replace(" ", "T") + "Z";

    const d = new Date(isoUTC);
    if (isNaN(d.getTime())) return dateString;

    // Format using the user's current locale + timezone
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };

    // Example output: "2025-11-27 18:42:10"
    const formatted = d.toLocaleString(undefined, options);

    // Standardize separators
    return formatted.replace(",", "");
  };

  const [maxTagsLimit, setMaxTagsLimit] = useState(10);

  const fetchMaxTags = async () => {
    try {
      const userMail = sessionStorage.getItem("mail");
      if (!userMail) return;

      const userDetails = await ManageUser.getUserDetails(userMail);
      const planId = userDetails?.getPlan();

      if (planId !== undefined && planId !== null) {
        const sp = new StoragePlan();
        const plan = await sp.getPlan(planId);
        if (plan && typeof plan.getTags === "function") {
          const limit = plan.getTags();
          if (typeof limit === "number") {
            setMaxTagsLimit(limit);
          } else if (limit && typeof limit.toNumber === "function") {
            setMaxTagsLimit(limit.toNumber());
          }
        }
      }
    } catch (error) {
      console.error("Error fetching max tags limit:", error);
    }
  };

  const fetchDetails = async () => {
    try {

      let dupCurrentPath = currentPath;
      if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 1);
        dupCurrentPath = newPath;
      }

      let fileName = selectedRow.name;
      if (dupCurrentPath[0] === "external_shared" && dupCurrentPath.length === 1) {
        fileName = selectedRow.uuids;
      }
      if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
        fileName = selectedRow.uuids;
      }

      const formattedPath =
        dupCurrentPath?.length === 0 ? "" : `/${dupCurrentPath?.join("/")}`;

      const fullPath = `${formattedPath}/${fileName}`;
      const item = await Item.getItem(fullPath, false);

      let type = "Unknown";
      let size = "0";
      let storage = "0";
      let owner = "Unknown";
      let modifiedDate = "Unknown";
      let createdDate = "Unknown";
      let tags = [];

      if (item instanceof Folder) {
        type = "Folder";
        size = "";
        storage = "";
        owner = item.getOwner();
        modifiedDate = convertUTCToLocal(item.getLastModifiedDateString());
        createdDate = convertUTCToLocal(item.getCreationDateString());
        setDetailsObj((prev) => ({ ...prev, isFolder: true }));
      } else if (item instanceof File) {
        setDetailsObj((prev) => ({ ...prev, isFolder: false }));
        fileName = selectedRow.name;
        type = fileName.split(".").pop() || "File";
        size = item.getSizeString();
        storage = item.getSizeString();
        owner = item.getOwner();
        modifiedDate = convertUTCToLocal(item.getLastModifiedDateString());
        createdDate = convertUTCToLocal(item.getCreationDateString());

        if (typeof item.getFileTags === "function") {
          tags = item.getFileTags() || [];
        }
      }

      await fetchMaxTags();

      setDetailsObj((prev) => ({
        ...prev,
        type,
        size,
        storage,
        owner,
        modifiedDate,
        createdDate,
        tags
      }));
    } catch (error) {
      console.error("Error fetching file/folder details:", error);
      showToast("Error fetching file details", "error");
    }
  };

  const handleUpdateTags = async () => {
    try {
      let dupCurrentPath = currentPath;
      if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 1);
        dupCurrentPath = newPath;
      }

      let fileName = selectedRow.name;
      if (dupCurrentPath[0] === "external_shared" && dupCurrentPath.length === 1) {
        fileName = selectedRow.uuids;
      }
      if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
        fileName = selectedRow.uuids;
      }

      const formattedPath =
        dupCurrentPath?.length === 0 ? "" : `/${dupCurrentPath?.join("/")}`;

      const fullPath = `${formattedPath}/${fileName}`;
      const item = await Item.getItem(fullPath, false);

      if (item instanceof File) {
        if (typeof item.setTags === "function" && typeof item.updateTags === "function") {
          // Process any pending tag input before saving
          const finalTags = [...detailsObj.tags];
          const pendingTags = tagInput.split(",").map(t => t.trim()).filter(t => t !== "");

          pendingTags.forEach(tag => {
            if (!finalTags.includes(tag) && finalTags.length < maxTagsLimit) {
              finalTags.push(tag);
            }
          });

          // if (finalTags.length > maxTagsLimit) {
          //   showToast(`Maximum ${maxTagsLimit} tags allowed`, "warning");
          //   return;
          // }

          item.setTags(finalTags);
          await item.updateTags();
          showToast("Tags updated successfully", "success");
          setIsEditingTags(false);
          setTagInput("");
          fetchDetails(); // Refresh to confirm updated state
        }
      }
    } catch (error) {
      console.error("Error updating tags:", error);
      showToast("Error updating tags", "error");
    }
  };

  const handleAddTag = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const tagsToAdd = tagInput.split(",").map(t => t.trim()).filter(t => t !== "");

      setDetailsObj(prev => {
        const newTags = [...prev.tags];
        let limitReached = false;

        tagsToAdd.forEach(tag => {
          if (!newTags.includes(tag)) {
            if (newTags.length < maxTagsLimit) {
              newTags.push(tag);
            } else {
              limitReached = true;
            }
          }
        });

        if (limitReached) {
          showToast(`Maximum ${maxTagsLimit} tags allowed`, "warning");
        }

        return { ...prev, tags: newTags };
      });
      setTagInput("");
    }
  };

  const removeTag = (tagToRemove) => {
    setDetailsObj(prev => ({
      ...prev,
      tags: prev.tags.filter(t => t !== tagToRemove)
    }));
  };

  useEffect(() => {
    fetchDetails();
  }, []);



  return (
    <div className="container fileInformationContainer">
      <div className="fileDataContainer">
        <div className="fileDetailsContainer">
          {!centered && <h5>File Details</h5>}
          <div className="fileTypeBox">
            <FileInfoChild fileType="Type" fileName={detailsObj?.type || "NoData"} />
            <FileInfoChild fileType="Size" fileName={detailsObj?.size || "NoData"} />
            <FileInfoChild fileType="Storage used" fileName={detailsObj?.storage || "NoData"} />
            <FileInfoChild fileType="Modified" fileName={detailsObj?.modifiedDate || "NoData"} />
            <FileInfoChild fileType="Created" fileName={detailsObj?.createdDate || "NoData"} />

            {/* Tags Feature */}
            {!detailsObj.isFolder && !isExternalShare && (
              <div className="tags-container">
                <p className="fileType">Tags</p>
                <div className="tags-content">
                  {!isEditingTags ? (
                    <div className="tags-display">
                      <div className="tags-list">
                        {detailsObj.tags && detailsObj.tags.length > 0 ? (
                          detailsObj.tags.map((tag, idx) => (
                            <span key={idx} className="tag-item">
                              <span className="tag-text">{tag}</span>
                            </span>
                          ))
                        ) : (
                          <span className="fileTypeName">No tags added</span>
                        )}
                      </div>
                      <button
                        className="edit-tags-button"
                        onClick={() => setIsEditingTags(true)}
                      >
                        Edit
                      </button>
                    </div>
                  ) : (
                    <div className="tags-edit">
                      <div className="tags-input-container">
                        <input
                          type="text"
                          className="tags-input"
                          placeholder="Add a tag..."
                          value={tagInput}
                          maxLength={80}
                          onChange={(e) => {
                            // Emoji prevention regex
                            const value = e.target.value.replace(/[\u{1F300}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E0}-\u{1F1FF}\u{1F680}-\u{1F6FF}\u{1F004}-\u{1F0CF}\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu, "");
                            if (value.length <= 80) {
                              setTagInput(value);
                            }
                          }}
                          onKeyDown={handleAddTag}
                          autoFocus
                        />
                        <div className="tags-edit-actions">
                          <button className="save-tags-button" onClick={handleUpdateTags}>Save</button>
                          <button className="cancel-tags-button" onClick={() => {
                            setIsEditingTags(false);
                            fetchDetails(); // Revert changes by re-fetching
                          }}>Cancel</button>
                        </div>
                      </div>
                      <div className="tags-list-edit">
                        {detailsObj.tags.map((tag, idx) => (
                          <span key={idx} className="tag-item-editable">
                            <span className="tag-text">{tag}</span>
                            <button
                              className="remove-tag-button"
                              onClick={() => removeTag(tag)}
                            >
                              &times;
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const FileInformation = ({
  isVisible,
  handleCancel,
  handleMange,
  titlen,
  selectedRow,
  currentPath,
  centered
}) => {
  const isMobile = useScreenMobile({ size: 992 });

  return isMobile && !centered ? (
    <Drawer
      isVisible={isVisible}
      handleCancel={handleCancel}
      heading="File Information"
      showFooter={false}
    >
      <FileInformationContent
        selectedRow={selectedRow}
        currentPath={currentPath}
        handleMange={handleMange}
        centered={centered}
      />
    </Drawer>
  ) : (
    <div className="modalBox">
      <Modal
        showFooter={false}
        handleCancel={handleCancel}
        heading="File Information"
      >
        <FileInformationContent
          selectedRow={selectedRow}
          currentPath={currentPath}
          handleMange={handleMange}
          centered={centered}
        />
      </Modal>
    </div>
  );
};

// export default FileInformation;

// const Files = () => {
//   const [manage, setManage] = useState("fileInfo");

//   useEffect(() => {
//     setManage("fileInfo");
//   }, []);
//   const handleMange = () => {
//     setManage("share");
//   };

//   return (
//     <>
//       {manage === "fileInfo" ? (
//         <FileInformation handleMange={handleMange} />
//       ) : manage === "share" ? (
//         <ShareProject
//           handleCancel={() => {
//             setManage(null);
//           }}
//         />
//       ) : null}
//     </>
//   );
// };

// export default Files;

// import React, { useEffect, useState } from 'react';

const Files = ({
  handleCancel,
  isVisible,
  setMenu,
  menu,
  title,
  selectedRow,
  currentPath,
  centered
}) => {

  const [manage, setManage] = useState("fileInfo");

  useEffect(() => {
    // Reset the manage state when file component is visible
    if (isVisible) {
      setManage("fileInfo");
    }
  }, [isVisible]);

  const handleMange = () => {
    setManage("share");
  };

  const handleClose = () => {
    setManage("");
    handleCancel(); // Calls the parent component's handleCancel to reset or close
  };



  return (
    <>
      <div className="fileComponentWrapper">
        {manage === "fileInfo" ? (
          <div className="fileInfo">
            {/* Add your file info UI */}
            {/* <h3>File Information</h3>
            <button onClick={handleMange}>Go to Share</button> */}
            <FileInformation
              selectedRow={selectedRow}
              currentPath={currentPath}
              handleCancel={handleCancel}
              handleMange={handleMange}
              isVisible={isVisible}
              centered={centered}
            />
          </div>
        ) : manage === "share" ? (
          <div className="fileShare">
            {/* Add your share UI */}
            {/* <h3>Share Project</h3>
            <button onClick={handleClose}>Close</button> */}
            <ShareProject handleCancel={handleClose} title={title} />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default Files;
